import React from 'react';
import { arrayOf, bool, func, string } from 'prop-types';
import { noop } from 'lodash';
import cn from 'classnames';
import { FILTER_CAROUSEL_TILE } from './constants';

import classes from './index.module.scss';

const Tile = ({ slug, title, image, selected, onClick = noop, disabled }) => (
    <div
        className={cn(
            classes.tile,
            { active: selected.includes(slug) },
            { disabled }
        )}
        onClick={() => onClick(slug)}
    >
        <div className={classes.icon}>
            <img src={image} alt={title} />
        </div>
        <div className={classes.title}>{title}</div>
    </div>
);

Tile.propTypes = {
    ...FILTER_CAROUSEL_TILE,
    selected: arrayOf(string),
    onClick: func,
    disabled: bool,
};

export default Tile;
